export const generateRoutePath = (routesAndParams: string[]) => {
    const route = routesAndParams.join('');
    return route;
};
